
import { Options, Vue } from "vue-class-component";
import { getStatusBarInfo, nativeGoBack, doJump, changeActionBar } from "@/utils/nativeFn";
import { testSign, testSignPost } from '@/api'
// import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'

@Options({
  components: {},
})
export default class Test extends Vue {
  mounted() {
    console.log("page loaded");
    setTimeout(() => {
      testSign()
      testSignPost()
    }, 200)
  }
  /**
   * name
   */
  doJumpFn(type) {
    let path = "";
    switch (type) {
      case 1:
        path = `10001?parameters=${encodeURIComponent(
          JSON.stringify({
            url: "https://www.baidu.com",
            title: "我是baidu",
            pageFrom: "test",
            source: 2,
          })
        )}`;
        break;
      case 2:
        path = `10001?parameters=${encodeURIComponent(
          JSON.stringify({
            url: "http://10.14.149.139:8080/ibook/#/landing-page",
            pageFrom: "test",
            source: 1,
          })
        )}`;
        break;
      case 3:
        path = `10002?parameters=${encodeURIComponent(
          JSON.stringify({
            fromFlag: 1,
            scanStr: "https://presscode.xueersi.com/index/scan?id=5561 ",
            pageFrom: "test",
          })
        )}`;
        break;
      case 4:
        path = `10003`;
        break;
      default:
        break;
    }
    doJump(path, () => {
      console.log("跳转成功");
    });
  }
  goback() {
    nativeGoBack({}, (res) => {
      console.log("h5调用端上nativeGoBack", res); // app返回给前端的值
    });
  }
  getStatusBarInfoFn() {
    getStatusBarInfo({}, (res) => {
      console.log("h5调用端上getStatusBarInfo", res); // app返回给前端的值
    });
  }
  closeActionBar() {
    changeActionBar({title: '', show: false}, () => {})
  }
  openActionBar() {
    changeActionBar({title: '', show: true}, () => {})
  }
}
